import { render, staticRenderFns } from "./DocumentTypeEditor.vue?vue&type=template&id=5796ec3a"
import script from "./DocumentTypeEditor.vue?vue&type=script&lang=js"
export * from "./DocumentTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports